<template>
  <v-row>
    <v-col cols="12">
      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/orders" exact>Todas las órdenes</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/orders?status=draft" exact>Borrador</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/orders?status=finalized" exact>Finalizado</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.orders.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Órdenes</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="order" class="mr-1" />
              <v-btn :to="{name: 'OrderCreate'}" outlined color="secondary"><v-icon left small>mdi-plus</v-icon> Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <order-list :show-create="true" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import OrderList from '@/components/order/OrderList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    OrderList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: [
      {
        type: 'text',
        id: 'customer__name',
        label: 'Cliente',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'date',
        label: 'Fecha',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'amount',
        label: 'Total',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'number',
        label: 'Número',
        operators: ['es igual', 'es menor a', 'es mayor a']
      }
    ]
  }),
  methods: {
    getList () {
      this.$store.dispatch('orders/LIST', {
        resource: 'orders',
        query: this.$route.query
      })
    }
  }
}
</script>